import React from 'react'
import config from './config'
import { InvoiceStatus } from 'src/generated/graphql'
import { Status } from 'components/Status'

export const InvoiceStatusWidget = ({ status }: { status: InvoiceStatus }) =>
  status && <Status {...config[status]} status={status} />
